<style lang="stylus">
    .FloatOption-container
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        width 25px
        height 25px
        z-index 1
        user-select none
        .FloatOption-onebtn
            border-radius 50%
            width 25px
            height 25px
            cursor pointer
            .item-icon
                width 25px
                height 25px
                fill #484b64
        .FloatOption-showbox
            position absolute
            top 25px
            display flex
            flex-wrap wrap
            width max-content
            overflow auto
            background-color #fff
            box-shadow 0 8px 24px 0 rgba(0,0,0,0.2)
            padding 10px 20px 10px 5px
            border-radius 4px
            .swimlane-box
                overflow auto
                &:not(:last-child)
                    margin-bottom 10px
            .iview_input
                float left
                width 69px
                height 24px
                margin-left 20px
                .ivu-input-number-input-wrap
                    height 24px
                .ivu-input-number-handler
                    height 12px
                input
                    display block
                    height 24px
                    line-height 24px
            .optionbox-btn
                float left
                height 24px
                margin-left 15px
                cursor pointer
                &:hover
                    background-color $main-hovercolor
                .item-icon
                    width 23px
                    height 23px
                    float left
                    margin-left 5px
            .optionbox-color
                float left
                width 24px
                height 24px
                margin-left 15px
                border-radius 5px
                border 1px solid #c4c4c4
                cursor pointer
            p
                float left
                padding-left 15px
                line-height 24px
                text-align right
    .FloatOption-ignore
        display none
</style>

<template>
    <div
        ref="floatOption"
        class="FloatOption-container"
        :style="{ left: `${left}px`, top: `${top}px` }"
        :class="{ 'FloatOption-ignore': isToolOperating }"
    >
        <div class="FloatOption-onebtn" @click="showbox()">
            <iconSymbol class="item-icon" name="option" />
        </div>

        <div ref="floatOptionShowbox" class="FloatOption-showbox" v-show="isShow" :style="{ left: `${ExpandLeft}px`, top: `${ExpandTop}px` }">
            <div v-show="floatItem.type == 'SwimLane' || floatItem.type == 'SwimContainer'">
                <div class="swimlane-box">
                    <p>{{ $t("lanes") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="swimlaneLanes"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                changeSpecialSet('setLane');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                changeSpecialSet('setLane');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                        :precision="0"
                        :max="99"
                        :min="1"
                    ></InputNumber>
                    <div class="optionbox-btn" @click="changeSpecialSet('orientation')">
                        <p>{{ $t("orientation") }}</p>
                        <iconSymbol class="item-icon" name="rightrotate"></iconSymbol>
                    </div>
                    <div class="optionbox-btn" @click="changeSpecialSet('textOrientation')">
                        <p>{{ $t("textOrientation") }}</p>
                        <iconSymbol class="item-icon" name="textbigger"></iconSymbol>
                    </div>
                </div>
                <div class="swimlane-box">
                    <div v-for="(color, i) in specialColor" :key="i">
                        <p>{{ i == 0 ? $t("optionbox-headColor") : $t("optionbox-bodyColor") }}</p>
                        <div class="optionbox-color" :style="{ backgroundColor: color }" @click="setSpecialColor($event, i)"></div>
                    </div>
                </div>
            </div>
            <div v-show="floatItem.type == 'TableUnit'">
                <p>{{ $t("rows") }}</p>
                <InputNumber
                    class="iview_input"
                    v-model="rows"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            changeSpecialSet('setRow');
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            changeSpecialSet('setRow');
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                    :precision="0"
                    :max="30"
                    :min="1"
                ></InputNumber>
            </div>
            <div v-show="floatItem.type == 'Entity'">
                <p>{{ $t("rows") }}</p>
                <InputNumber
                    class="iview_input"
                    v-model="rows"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            changeSpecialSet('setRow');
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            changeSpecialSet('setRow');
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                    :precision="0"
                    :max="15"
                    :min="1"
                ></InputNumber>
                <p>{{ $t("columns") }}</p>
                <InputNumber
                    class="iview_input"
                    v-model="columns"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            changeSpecialSet('setColumn');
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            changeSpecialSet('setColumn');
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                    :precision="0"
                    :max="15"
                    :min="1"
                ></InputNumber>
                <div
                    v-for="(color, i) in specialColor"
                    :key="i"
                    class="optionbox-color"
                    :style="{ backgroundColor: color }"
                    @click="setSpecialColor($event, i)"
                ></div>
            </div>

            <div v-show="floatItem.type == 'Matrix'">
                <p>{{ $t("rows") }}</p>
                <InputNumber
                    class="iview_input"
                    v-model="rows"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            changeSpecialSet('setRow');
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            changeSpecialSet('setRow');
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                    :precision="0"
                    :max="30"
                    :min="1"
                ></InputNumber>
                <p>{{ $t("columns") }}</p>
                <InputNumber
                    class="iview_input"
                    v-model="columns"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            changeSpecialSet('setColumn');
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            changeSpecialSet('setColumn');
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                    :precision="0"
                    :max="30"
                    :min="1"
                ></InputNumber>
                <div
                    v-for="(color, i) in specialColor"
                    :key="i"
                    class="optionbox-color"
                    :style="{ backgroundColor: color }"
                    @click="setSpecialColor($event, i)"
                ></div>
            </div>

            <div v-show="floatItem.type == 'FloorPlanWall'">
                <p>{{ $t("wallTitle") }}</p>
                <InputNumber
                    class="iview_input"
                    v-model="wallThickness"
                    :formatter="(value) => `${value}${wallUnit}`"
                    :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                    @on-focus="editLocker('focus', 'lockInput')"
                    @on-blur="
                        editLocker('blur', 'lockInput', () => {
                            setWallData('wallThickness');
                        })
                    "
                    @on-change="
                        editLocker('edit', 'lockInput', () => {
                            setWallData('wallThickness');
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                    :active-change="false"
                    :max="wallMax"
                    :min="wallMin"
                ></InputNumber>
                <Checkbox style="line-height: 24px; margin-left: 10px" v-model="wallCheck" @on-change="setWallData('wallCheck')">
                    {{ $t("wallCheckBox") }}
                </Checkbox>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";
    declare var egPoint: any;
    @Component({
        components: {},
    })
    export default class FloatOption extends Vue {
        @Inject()
        ["iviewInputBlur"];
        @Prop()
        itemID: number;

        ExpandLeft: number = 0;
        ExpandTop: number = 25;
        isShow: boolean = false;
        lockInput: boolean = false;
        wallCheck: boolean = false;
        wallTimer: number = 0;
        wallMin: number = 0;
        wallMax: number = 0;
        // tool
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        getFloatItemIndex() {
            let index = -1;
            for (let i = 0; i < this.FloatOptionList.length; i++) {
                if (this.itemID == this.FloatOptionList[i].id) {
                    index = i;
                    break;
                }
            }
            return index;
        }

        closeFunc(e) {
            let objTarget = this.$refs["floatOption"] as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.isShow = false;
                window.removeEventListener("click", this.closeFunc);
            }
        }
        showbox() {
            if (this.isShow) {
                this.isShow = false;
                window.removeEventListener("click", this.closeFunc);
                return;
            }
            this.isShow = true;
            window.addEventListener("click", this.closeFunc);
            let range = window["_view"].getWallRange();
            this.wallMin = range[0];
            this.wallMax = range[1];
            this.$nextTick(() => {
                this.adjustExpandBox();
            });
        }
        adjustExpandBox() {
            // 调整弹窗位置
            let dom = this.$refs["floatOptionShowbox"] as HTMLElement,
                rightMenu = this.$store.state.ui.showRightPanel ? 320 : 40,
                menuWidth = 0;
            let itemW = dom.offsetWidth,
                itemH = dom.offsetHeight,
                winW = window.innerWidth,
                winH = window.innerHeight,
                parentL = dom.getBoundingClientRect()["x"] - this.ExpandLeft,
                parentT = dom.getBoundingClientRect()["y"];
            if (itemH + parentT + 25 > winH) {
                this.ExpandTop = -itemH;
            } else {
                this.ExpandTop = 25;
            }
            if (itemW + parentL + rightMenu + menuWidth > winW) {
                this.ExpandLeft = 35 - itemW;
            } else {
                this.ExpandLeft = 0;
            }
            console.log(itemW, parentL, winW, this.ExpandLeft);
        }
        changeSpecialSet(type) {
            switch (type) {
                case "setLane": {
                    window["_view"].setSpecial(type, this.swimlaneLanes);
                    break;
                }
                case "setRow": {
                    window["_view"].setSpecial(type, this.rows);
                    break;
                }
                case "setColumn": {
                    window["_view"].setSpecial(type, this.columns);
                    break;
                }
                default:
                    window["_view"].setSpecial(type);
                    break;
            }
        }
        setWallData(type) {
            if (type == "wallThickness") {
                this.wallThickness = this.checkWallInput(this.wallThickness);
                this.wallTimer = setTimeout(() => {
                    window["_view"].setWallThickness(this.wallThickness, this.wallCheck);
                }, 100);
            } else if (type == "wallCheck") {
                clearTimeout(this.wallTimer);
                if (this.wallCheck) {
                    window["_view"].setWallThickness(this.wallThickness, this.wallCheck);
                }
            }
        }
        checkWallInput(number) {
            return window["_view"].checkWallThickness(number);
        }
        setSpecialColor(e, i) {
            this.$store.commit("setStatus", {
                type: "specialColorIndex",
                data: i,
            });
            this.showFillColor(e);
        }
        showFillColor(e) {
            if (!this.isSelect) return;
            window["_view"]._tool.endEdit();
            let node = e.target;
            let payload = {
                type: this.fmtType.fill,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "fillColor" });
            });
        }

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get isToolOperating() {
            return this.$store.state.shape.isToolOperating;
        }
        get FloatOptionList() {
            return this.$store.state.dialog.floatOptionList;
        }
        get left() {
            return this.floatItem.position ? this.floatItem.position[0] : 0;
        }
        get top() {
            return this.floatItem.position ? this.floatItem.position[1] : 0;
        }
        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        set activeFloatItem(v) {
            this.$store.commit("setDialogState", {
                type: "activeFloatItem",
                data: v,
            });
        }
        get floatItem() {
            let index = this.getFloatItemIndex();
            return this.FloatOptionList[index] || {};
        }
        get activeHoverFloatID() {
            return this.$store.state.dialog.activeHoverFloatID;
        }
        set activeHoverFloatID(v) {
            this.$store.commit("setDialogState", {
                type: "activeHoverFloatID",
                data: v,
            });
        }

        get swimlaneLanes() {
            return this.$store.state.shape.lanes;
        }
        get rows() {
            return this.$store.state.shape.rows;
        }
        get columns() {
            return this.$store.state.shape.columns;
        }
        get specialColor() {
            return this.$store.state.shape.specialColor;
        }
        get wallThickness() {
            return this.$store.state.shape.planSet.wallThickness;
        }
        set swimlaneLanes(v) {
            this.$store.commit("setShapeStatus", { type: "lanes", data: v });
        }
        set rows(v) {
            this.$store.commit("setShapeStatus", { type: "rows", data: v });
        }
        set columns(v) {
            this.$store.commit("setShapeStatus", { type: "columns", data: v });
        }
        set wallThickness(v) {
            this.$store.commit("setPlanSetData", { type: "wallThickness", data: v });
        }
        get wallUnit() {
            let pageUnitList = ["mm", "cm", "m", "km", "in", "ft and in", "ft", "yd", "mi", "pt", "Pica", "Didot", "Cicero", "px"];
            return pageUnitList[this.$store.state.shape.planSet.unit];
        }
        mounted() {}
        created() {}
        beforeDestroy() {}
    }
</script>
<i18n>
{
  "zh": {
    "lanes": "泳道",
    "rows": "行",
    "columns": "列",
    "orientation": "改变方向",
    "showOrHideTitle": "显示隐藏标题",
    "textOrientation": "改变文本方向",
    "dragTitle": "查找和替换",
    "wallTitle": "墙厚度",
    "wallCheckBox": "所有的墙壁",
    "optionbox-headColor": "顶部颜色",
    "optionbox-bodyColor": "泳道颜色"
  },
  "en": {
    "lanes": "Lanes",
    "rows": "Rows",
    "columns": "Columns",
    "orientation": "Change Orientation",
    "showOrHideTitle": "Show/Hide Title",
    "textOrientation": "Change Text Orientation",
    "dragTitle": "Find & Replace",
    "wallTitle": "Wall Thickness",
    "wallCheckBox": "All Walls",
    "optionbox-headColor": "Top Color",
    "optionbox-bodyColor": "Swim Lane Color"
  },
  "de": {
    "lanes": "Wege",
    "rows": "Zeile",
    "columns": "Spalte",
    "orientation": "Orientierung ändern",
    "showOrHideTitle": "Titel zeigen/verbergen",
    "textOrientation": "Textrichtung ändern",
    "dragTitle": "Suchen und Ersetzen",
    "wallTitle": "Wandstärke",
    "wallCheckBox": "Alle Wände",
    "optionbox-headColor": "Kopffarbe",
    "optionbox-bodyColor": "Swimlane-Farbe"
  },
  "fr": {
    "lanes": "Lane",
    "rows": "Ligne",
    "columns": "Colonne",
    "orientation": "Changer de direction",
    "showOrHideTitle": "Afficher le titre masqué",
    "textOrientation": "Changer la direction du texte",
    "dragTitle": "Rechercher et remplacer",
    "wallTitle": "Épaisseur de paroi",
    "wallCheckBox": "Tous les murs",
    "optionbox-headColor": "Couleur du haut",
    "optionbox-bodyColor": "Couleur de voie"
  },
  "jp": {
    "lanes": "レーン",
    "rows": "行",
    "columns": "列",
    "orientation": "方向付け",
    "showOrHideTitle": "タイトルの表示又は非表示",
    "textOrientation": "テキストの方向を変更",
    "dragTitle": "検索と置き換え",
    "wallTitle": "壁の厚さ",
    "wallCheckBox": "すべての壁",
    "optionbox-headColor": "ボックスヘッドカラー",
    "optionbox-bodyColor": "レーンの色"
  },
  "es": {
    "lanes": "Carriles",
    "rows": "Filas",
    "columns": "Columnas",
    "orientation": "Cambiar orientación",
    "showOrHideTitle": "Mostrar / Ocultar título",
    "textOrientation": "Cambiar orientación del texto",
    "dragTitle": "Buscar y reemplazar",
    "wallTitle": "Espesor de pared",
    "wallCheckBox": "Todas las paredes",
    "optionbox-headColor": "Color superior",
    "optionbox-bodyColor": "Color de Carriles"
  },
  "pt": {
    "lanes": "Faixas",
    "rows": "Linhas",
    "columns": "Colunas",
    "orientation": "Alterar Orientação",
    "showOrHideTitle": "Mostrar/Esconder Título",
    "textOrientation": "Alterar Orientação do Texto",
    "dragTitle": "Encontrar & Substituir",
    "wallTitle": "Espessura de Parede",
    "wallCheckBox": "Todas as Paredes",
    "optionbox-headColor": "Cor Superior",
    "optionbox-bodyColor": "Cor da Raia"
  },
  "it": {
    "lanes": "Corsie",
    "rows": "Righe",
    "columns": "Colonne",
    "orientation": "Modifica Orientamento",
    "showOrHideTitle": "Mostra/Nascondi Titolo",
    "textOrientation": "Modifica Orientamento del Testo",
    "dragTitle": "Trova e Sostituisci",
    "wallTitle": "Spessore Parete",
    "wallCheckBox": "Tutte le Pareti",
    "optionbox-headColor": "Colore Parte Superiore",
    "optionbox-bodyColor": "Colore Corsia"
  },
  "tw": {
    "lanes": "泳道",
    "rows": "行",
    "columns": "列",
    "orientation": "改變方向",
    "showOrHideTitle": "顯示隱藏標題",
    "textOrientation": "改變文本方向",
    "dragTitle": "查找和替換",
    "wallTitle": "墻厚度",
    "wallCheckBox": "所有的墻壁",
    "optionbox-headColor": "頂部顏色",
    "optionbox-bodyColor": "泳道顏色"
  },
  "kr": {
    "lanes": "레일",
    "rows": "행",
    "columns": "열",
    "orientation": "방향 변경",
    "showOrHideTitle": "제목 표시/숨기기",
    "textOrientation": "텍스트 방향 변경",
    "dragTitle": "찾기 및 바꾸기",
    "wallTitle": "벽 두께",
    "wallCheckBox": "모든 벽",
    "optionbox-headColor": "상단 색깔",
    "optionbox-bodyColor": "레일 색깔"
  }
}
</i18n>
